import { uniqBy } from 'lodash';

function getVisibleLinks(hoverSelection, linkPathsPerIcon, clickSelection,
  connectionChains, chainSelection) {

  function filterBySelection(links, selection){
    // filter the links if a clickselection has been made
    let filteredLinks = [];

    const allHighlightedIcons = [
      ...connectionChains[selection]['directIcons'],
      ...connectionChains[selection]['chainIcons']
    ];
    links.forEach((link, i) => {
      const icons = link['link'].split('_to_');
      if(
        allHighlightedIcons.indexOf(+icons[0]) > -1 &&
        allHighlightedIcons.indexOf(+icons[1]) > -1
      ){
        filteredLinks.push(link)
      }
    });

    return filteredLinks;
  }


  let links = [];
  if(hoverSelection !== -1){
    links = linkPathsPerIcon[hoverSelection];
  }
  if(chainSelection !== -1){
    links = [...links, ...linkPathsPerIcon[chainSelection]];
  }
  links = uniqBy(links, 'link');



  if(clickSelection !== -1){
    links = filterBySelection(links, chainSelection)
    // links = filterBySelection(links, clickSelection)
  }
  // console.log(links)
  return links;

}

export default getVisibleLinks;
